/**
 * Diretiva responsável por criar um componente checkbox customizado para a aplicação. 
 */

angular.module("avlib").directive("avCheckbox", function(){
	return {
		template: require("!html-loader!./CheckboxTemplate.html"),
		restrict: "E",
		scope: {
			label: '@',
			ngModel: '=',
			ngChange: '&',
			ngDisabled: '&',
		},
		
		controller: ["$scope", function($scope){
			$scope.checkboxClicked = function(event){
				if (!$scope.isDisabled()){
					$scope.ngModel = !$scope.ngModel;
				}
			};
			
			$scope.isDisabled = function(){
				return $scope.ngDisabled();
			};
			
			$scope.$watch('ngModel', function(newValue, oldValue){
				if (newValue != oldValue){
					$scope.ngChange();
				}
			});
		}],
	};
});
